
import React, { useEffect, useState } from 'react'
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import { FiSettings } from 'react-icons/fi';
import { toast, ToastContainer } from 'react-toastify';
import { getCountryApi, getIndustryAll, getLocations, getProfileApi, profileUpdate } from '../apifile/ApiFiles';
import { Loaders } from '../../pages/Loaders';

const Profile = () => {
    const [loader, setLoader] = useState(false)
    const [initialVal, setInitialVal] = useState({
        company_type: "",
        company_website: "",
        industry_type: "",
        company_city: '',
        company_country: '',
        pinCode: '',
        mobile: '',
        email: '',
        firstname: '',
        lastname: ''
    });


    const changeHandler = (e) => {
        const clone = { ...initialVal };
        const value = e.target.value;
        const name = e.target.name;
        clone[name] = value;
        setInitialVal(clone);
    };


    // const getById = async (id) => {
    //     const res = await axios.get(
    //         `https://abarishr.hennainternational.in/api/language/${params?.id}`
    //     );
    //     setInitialVal(res?.data);
    // };

    // useEffect(() => {
    //     if (params?.id) {
    //         getById();
    //     }
    // }, []);

    const notify = (updateMassage) => toast(updateMassage);
    const [industryData, setIndustryData] = useState(null)
    // console.log(industryData);

    const [countryData, setCountrData] = useState(null)
    const [cityData, setCityData] = useState(null)

    const dataApiget = async () => {
        try {
            const resCountry = await getCountryApi()
            setCountrData(resCountry?.data)
            const rescity = await getLocations()
            setCityData(rescity?.data)
            const resIndustry = await getIndustryAll()
            setIndustryData(resIndustry?.data)
        } catch (error) {

        }
    }

    const updateHandle = async () => {
        setLoader(true)
        const clone = { ...initialVal }
        console.log(clone);

        try {
            const res = await profileUpdate(clone)
            // console.log(res?.data);
            if (res?.data?.error == false) {
                notify(res?.data?.message)
                getDataProfile()
                setLoader(false)
            } else {
                setLoader(false)
                alert('server side error')
            }
        } catch (error) { setLoader(false) }
    };


    const getDataProfile = async () => {
        setLoader(true)
        try {
            const res = await getProfileApi()
            const profile = res?.data?.data
            setInitialVal({
                ...profile
            })
            setLoader(false)
        } catch (error) {
            setLoader(false)
        }
    }

    useEffect(() => {
        dataApiget()
        getDataProfile()
    }, [])

    return (
        <>
            {loader && <Loaders />}
            <div className="pageTableWrapper">
                <ToastContainer />

                <div className="pageBody">
                    <div className="pageTable">
                        <form>
                            <div className="row">
                                {/* Name */}
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <label htmlFor="name">
                                        <strong>First Name</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="name"
                                        placeholder="First Name"
                                        dir="ltr"
                                        type="text"
                                        name="firstname"
                                        value={initialVal?.firstname}
                                        onChange={changeHandler}
                                    />
                                </div>
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <label htmlFor="name">
                                        <strong>Last Name</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="name"
                                        placeholder="Last Name"
                                        dir="ltr"
                                        type="text"
                                        name="lastname"
                                        value={initialVal?.lastname}
                                        onChange={changeHandler}
                                    />
                                </div>

                                {/* Phone */}
                                <div className="col-md-4 col-sm-6 mb-3">
                                    <label htmlFor="phone">
                                        <strong>Phone</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="phone"
                                        placeholder="Phone"
                                        dir="ltr"
                                        type="number"
                                        name="mobile"
                                        value={initialVal?.mobile}
                                        onChange={changeHandler}
                                    />
                                </div>

                                {/* Email */}
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="email">
                                        <strong>Email</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="email"
                                        placeholder="Email"
                                        dir="ltr"
                                        type="email"
                                        name="email"
                                        value={initialVal?.email}
                                        onChange={changeHandler}
                                    />
                                </div>
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="email">
                                        <strong>Company Type</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="email"
                                        placeholder="Company Type"
                                        dir="ltr"
                                        type="text"
                                        name="company_type"
                                        value={initialVal?.company_type}
                                        onChange={changeHandler}
                                    />
                                </div>
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="email">
                                        <strong>Company Website</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="email"
                                        placeholder="Company Website"
                                        dir="ltr"
                                        type="text"
                                        name="company_website"
                                        value={initialVal?.company_website}
                                        onChange={changeHandler}
                                    />
                                </div>
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="email">
                                        <strong>Industry</strong>
                                    </label>
                                    <select className="form-select" aria-label="Default select example" name="industry_type"
                                        value={initialVal?.industry_type}
                                        onChange={changeHandler}>
                                        <option selected>Open this select menu</option>
                                        {industryData && industryData?.data?.map((item) => {
                                            return <option value={item?._id}>{item?.industry}</option>
                                        })}
                                    </select>

                                </div>
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="email">
                                        <strong>Location / City</strong>
                                    </label>
                                    <select className="form-select" aria-label="Default select example" name="company_city"
                                        value={initialVal?.company_city}
                                        onChange={changeHandler}>
                                        <option selected>Open this select menu</option>
                                        {cityData && cityData?.map((item) => {
                                            return <option value={item?._id}>{item?.location_name}</option>
                                        })}
                                    </select>

                                </div>
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="email">
                                        <strong>Country</strong>
                                    </label>
                                    <select className="form-select" aria-label="Default select example" name="company_country"
                                        value={initialVal?.company_country}
                                        onChange={changeHandler}>
                                        <option selected>Open this select menu</option>
                                        {countryData && countryData?.data?.map((item) => {
                                            return <option value={item?._id}>{item?.country}</option>
                                        })}
                                    </select>

                                </div>
                                <div className="col-md-4 col-sm-12 mb-3">
                                    <label htmlFor="pincode">
                                        <strong>Pin Code</strong>
                                    </label>
                                    <input
                                        className="form-control"
                                        id="pincode"
                                        placeholder="Pin Code"
                                        dir="ltr"
                                        type="number"
                                        name="pinCode"
                                        value={initialVal?.pinCode}
                                        onChange={changeHandler}
                                    />
                                </div>
                            </div>
                        </form>
                        <div className="pageFooter text-center mt-2">
                            <button
                                className="btn btn-large btn-primary"
                                type="button"
                                onClick={updateHandle}
                            >
                                Update <BsFillArrowRightCircleFill />
                            </button>
                        </div>
                    </div>

                </div>


            </div>
        </>
    );
}

export default Profile